import { AxiosPromise } from 'axios';

import { hosts } from '@/app/config';
import { BaseClient } from '@/clients/BaseClient/BaseClient';
import { AddCandidateNoteDto } from '../model';

class RecruiterRejectsCandidateClient extends BaseClient {
  rejectAppliedCandidate(esPersonId: string, campaignId: number, improvedJobId?: number): AxiosPromise<void> {
    return this.request({
      url: `${hosts.campaignsApi}/campaigns/${campaignId}/candidates/${esPersonId}/candidate_applied_recommendation_rejected/`,
      method: 'POST',
      data: { improved_job_id: improvedJobId },
    });
  }

  addCandidateNote(esPersonId: string, dto: AddCandidateNoteDto): AxiosPromise<void> {
    return this.request({
      url: `${hosts.campaignsApi}/candidates/${esPersonId}/notes/`,
      method: 'POST',
      data: dto,
    });
  }

  hideCandidate(esPersonId: string, campaignId: number): AxiosPromise<void> {
    return this.request({
      url: `${hosts.campaignsApi}/campaigns/${campaignId}/candidates/`,
      method: 'POST',
      data: { es_person_id: esPersonId, status: 'HIDDEN' },
    });
  }
}

export const recruiterRejectsCandidateClient = new RecruiterRejectsCandidateClient();
